<template>
    <div class="article-container">
        <div class="main-article">
            <div class="article-subject">
                <p class="date">{{activeInfo.updateTime}} ——</p>
                <p class="subject">
                    {{ activeInfo.activityName }}
                </p>
            </div>
            <div class="author">
                <p>{{activeInfo.tenantName}}-{{getActivityType(activeInfo.tenantType)}}</p>
            </div>
            <div class="article">
                <div class="img-area" v-if="type==1">
                    <div :class="['img-item left','item-first']" v-for="(item,index) in activeInfo.contentPics" :key="index">
                        <img v-if="item.id" :src="'resrun-paas/file/downloadFileStream/'+item.id" width="100%"  alt="" />
                    </div>
                </div>
                <p v-if="type==2" class="tiny-content"  ref="contentRef" v-html="activeInfo.activityContent" :style="{height:innerHeight-400+ 'px'}"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import { getCopyrightActiveInfo } from '@/api/business'
    import {getActivityType} from "./state"
    export default {
        name:'activeDetail',
        components:{
        },
        data () {
            return {
                id:'',
                activeInfo:{
                    activityName:'',
                    contentPics:[]
                },
                innerHeight:window.innerHeight,
                type:1,
                getActivityType
            }
        },
        mounted() {
            this.init();
        },
        methods: {

            init(){
                this.id = this.$route.params.id;
                this.type = this.$route.params.type;

                if(this.id){
                    getCopyrightActiveInfo({id:this.id}).then(res=>{
                        if(res.code==200){
                            this.activeInfo = res.result;
                        }
                    })
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .main-article{
        width: 1200px;
        margin: 68px auto 0;
        text-align: left;
    }
    .article-subject{
        display: flex;
        .date{
            font-family: Source Han Sans CN;
            font-size: 0.32rem;
            font-weight: 600;
            line-height: .48rem;
            color: #2C1D50;
        }
        .subject{
            flex:1;
            font-family: Source Han Sans CN;
            font-size: .24rem;
            font-weight: 600;
            line-height: .48rem;
            padding-left: 0.1rem;
            color: #2C1D50;
        }
    }
    .author{
        font-family: Source Han Sans CN;
        font-size: .14rem;
        font-weight: 700;
        color: #2C1D50;
        padding-left: 1.81rem;
        line-height: 0.3rem;
        position: relative;
        padding-bottom: 0.15rem;
    }
 
    .author::after{
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 0.01rem;
        width: 100%;
        background-color: #EFEFEF;
    }
    .main-article{
        display: block;
        padding: 0.6rem 0;
        .article{
            padding-top: 0.3rem;
            overflow-x: auto;
            .img-area{
                width: 8rem;
                margin: 0 auto;
            }
        }
    }
</style>